<div class="teaser-container mb-2">
  @for (item of knowHow | discoverSlide: slide : itemsPerSlide; track item.id) {
    <div class="know-how-item" (click)="openDetails.emit(item.id)">
      <img class="know-how-img" [src]="discoverAssetHost + '/' + item.imageUrl" alt="know-how-teaser" />
      <div class="know-how-title">
        {{ item.title }}
      </div>
    </div>
  }
</div>
@if (knowHow?.length > itemsPerSlide) {
  <discover-paging [itemsPerSlide]="itemsPerSlide" [size]="knowHow.length" (slideChange)="slide = $event" />
}
